import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TimeConfigForm from './forms/TimeConfigForm';
import TimeConfigList from './lists/TimeConfigList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class TimeConfigEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Időpontok"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <TimeConfigList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Időpont"}
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <TimeConfigForm {...this.props} />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "TimeConfig",
    WrappedComponent: TimeConfigEditor,
    props: {
        componentActions: (action, data, params) => {
            data = {...data};
            data.program = (data.program || {}).id || null;
            data.location = (data.location || {}).id || null;
            return {action,data,params};
        }
    }
});
